const CATEGORY_EXCLUSIONS = [
  'Tobacconists',
  'Adult Shops',
  'Escorts',
  'Adult Entertainment & Escorts',
];

export default CATEGORY_EXCLUSIONS;
